import React, { useState } from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../ui/tabs';
import { useAdminInbox } from '../../hooks/useAdminInbox';
import { AdminOverview } from './AdminOverview';
import { AdminRecords } from './AdminRecords';
import { AdminConversations } from './AdminConversations';
import { AdminAlerts } from './AdminAlerts';
import { EnquiryReviewPanel } from '../experience/EnquiryReviewPanel';

export const AdminDashboard = ({ copy, lang }) => {
  const inbox = useAdminInbox();
  const [record, setRecord] = useState(null);
  return <section className="bg-white py-10"><div className="mx-auto max-w-6xl px-6 pb-16">
    <AdminOverview inbox={inbox} copy={copy} />
    <Tabs defaultValue="demos"><TabsList className="bg-slate-100 admin-tabs">{['demos', 'leads', 'chats', 'alerts'].map(tab => <TabsTrigger key={tab} value={tab} data-testid={`admin-tab-${tab}`}>{copy[tab]}</TabsTrigger>)}</TabsList>
      <TabsContent value="demos" className="mt-6"><AdminRecords kind="demo" rows={inbox.demos} copy={copy} lang={lang} onReview={setRecord} /></TabsContent>
      <TabsContent value="leads" className="mt-6"><AdminRecords kind="lead" rows={inbox.leads} copy={copy} lang={lang} onReview={setRecord} /></TabsContent>
      <TabsContent value="chats" className="mt-6"><AdminConversations sessions={inbox.chats} copy={copy} lang={lang} onReview={setRecord} /></TabsContent>
      <TabsContent value="alerts" className="mt-6"><AdminAlerts notifications={inbox.alerts} copy={copy} lang={lang} /></TabsContent>
    </Tabs>
    {record && <EnquiryReviewPanel key={`${record.kind}-${record.id}`} record={record} onClose={() => setRecord(null)} />}
  </div></section>;
};